import axios from "axios";

export function getPetProfile(petId) {
  return api.get(`/kinPetProfile/pets/${petId}`);
}

export function getVaccineTypes() {
  return api.get('kin/content/v1/vaccines.json');
}

export function addPetVaccination(petId, vaccineName, administeredDate, renewalDate, type) {
  return api.post(`/kinPetProfile/pets/${petId}/vaccines`, {
    vaccineName,
    administeredDate,
    renewalDate,
    type,
  });
}

export function editPetVaccination(petId, oldVaccineType, vaccineName, administeredDate, renewalDate, type) {
  return api.patch(`/kinPetProfile/pets/${petId}/vaccines/${oldVaccineType}`, {
    vaccineName,
    administeredDate,
    renewalDate,
    type
  });
}

export function deletePetVaccination(petId, vaccineType) {
  return api.delete(`/kinPetProfile/pets/${petId}/vaccines/${vaccineType}`);
}

export function deleteAllPetVaccination(petId) {
  return api.delete(`/back4app/vaccines/delete_all/${petId}`);
}

export function updatePet(petId, weight, microchipId) {
  return api.patch(`/kinPetProfile/pets/${petId}`, {
    "weight": weight,
    "microchipId": microchipId,
  });
}

export function uploadDocument(petId, formData) {
  return api.post(`/document/documents/vet_records/${petId}`, formData);
}

export function getMedicalRecordRequets(petId) {
  return api.get(`/back4app/medical_records/records_requests/${petId}`);
}

export function updateMedicalRecordRequestStatus(id, status) {
  return api.patch(`/back4app/medical_records/records_request/${id}`, { status });
}

export function updateDocumentVetName(documentUrl, value) {
  return api.put(`/document/documents/attributes?documentUrl=${encodeURIComponent(documentUrl)}`, {
    "vet-name": value,
  });
}

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'The Kin',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}`,
  timeout: 20000,
});